import Vue from 'vue';
import store from './../../store';
import transTransformer from './../../transformers/warehouseTransactionV2';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const transactionsV2All = transTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllWarehouseTransactionsV2', transactionsV2All);
  resolve(transactionsV2All);
};

const failed = (error, reject) => reject(error);

export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl(`warehouses/${options.id}/transactionsV2`, options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/warehouse/transactionsV2All.js